<script>
    export let finding;
    export let level = 1;
    export let displayType = "html";
</script>

<style>
    pre {
        font-family: "Lato","Helvetica Neue",Helvetica,Arial,sans-serif;
        padding: 0;
        white-space: pre-wrap;
    }
</style>

<table class="table is-fullwidth">
{#each Object.entries(finding) as key (key[0])}
<tr>
    <td>
        <slot name="key" key={key[0]}>
            <strong>{key[0]}</strong>
        </slot>
    </td>
    <td>
        {#if typeof key[1] == "object" && key[1] != null}
            <svelte:self finding={key[1]} level={level+1} {displayType} />
        {:else}
            {#if displayType == "html"}
                <div class="content" style="padding-left: {level*10}px">{@html key[1]}</div>
            {:else}
                <div class="content" style="padding-left: {level*10}px"><pre>{key[1]}</pre></div>
            {/if}
        {/if}
    </td>
</tr>
{/each}
</table>